import React from "react";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import DashboardCard from "../components/DashboardCard";

const ADVERTISE_PROPERTY_PATH = "/advertise-property";

export default function AdvertisePropertyCTA({ smDown }: { smDown: boolean }) {
  return (
    <DashboardCard padding={smDown ? "1rem" : "1.25rem"}>
      <div className="flex flex-col items-center gap-4 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-[#6ea8ff]/30 bg-[#6ea8ff]/10">
            <Megaphone className="h-6 w-6 text-[#6ea8ff]" />
          </div>
          <div>
            <h3 className="text-sm font-bold text-[#f0f6fc] sm:text-base">Realizar novo anúncio</h3>
            <p className="mt-1 text-xs text-[#8b949e] sm:text-sm">
              Cadastre mais um imóvel e amplie sua carteira na 7Cantos
            </p>
          </div>
        </div>
        <Link
          to={ADVERTISE_PROPERTY_PATH}
          target="_blank"
          rel="noreferrer"
          className="shrink-0 rounded-full bg-[#6ea8ff] px-5 py-2.5 text-xs font-bold text-[#0d1117] transition-opacity hover:opacity-90 sm:text-sm"
        >
          Novo anúncio
        </Link>
      </div>
    </DashboardCard>
  );
}
